import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { blogPost } from '../../../Models/Session';
import { AuthService } from '../../../Services/auth.service';
import { BaseApiService } from '../../../Services/base-api.service';
import { ImageUploadService } from '../../../Services/image-upload.service';
import { RichTextEditorService } from '../../../Services/rich-text-editor.service';


@Component({
  selector: 'app-blog-posts',
  templateUrl: './blog-posts.component.html',
  styleUrls: ['./blog-posts.component.css']
  ,standalone:false

})
export class BlogPostsComponent implements OnInit {

  visible:boolean=false
  sessionDataArray: blogPost[] = [];
  sessionData1: blogPost[] = [];
  selectedRecord!: blogPost;
  editorContent: string = "";
  recordForm!: FormGroup;
  selected:boolean=false;
  loading:boolean=false;
  imageUrl: string = '';
  userId:string
  constructor
  (
    private api:BaseApiService,
    private imageUploadService:ImageUploadService,
    private auth:AuthService,
    private editorService: RichTextEditorService,
    private http:HttpClient,private messageService:MessageService,private fb: FormBuilder)
  {

      this.userId=this.auth.getUID();


  }
  getdat(){
    this.loading=true;
    this.api.read("Blog").subscribe
    (
      (response)=>{
        this.sessionDataArray = response;
        this.loading=false;
      }
      ,(
        error
      )=>{
        this.loading=false;
       
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
      }
    )
  }
  ngOnInit(): void {
    this.recordForm = this.fb.group({
      id: new FormControl(0),
      title: new FormControl('', [Validators.required]),
      description: new FormControl('', [Validators.required]),
      metaDescription: new FormControl('', [Validators.required]),
      image:new FormControl('', [Validators.required]),
      userId: new FormControl(null,[Validators.required])
    });
    this.editor();
    this.getdat();

    if (this.sessionDataArray && this.sessionDataArray.length > 0) {
        this.recordForm.patchValue(this.selectedRecord);
    }

   }


   selectRecord(record: any) {
    this.selected=true;
    this.selectedRecord = record;
    this.recordForm.get('userId')?.setValue(this.userId);
    this.imageUrl=this.selectedRecord.image;
    this.editorService.setEditorContent(this.selectedRecord.description);
    this.recordForm.patchValue(record);

  }

  deRecord(id:any) {
    this.loading=true;
    
    this.api.delete(`Blog?id=${id}`).subscribe
    (
      (response)=>{
        this.loading=false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: response.message });
        this.getdat();
        this.recordForm.reset();
      }
      ,(
        error
      )=>{
        this.loading=false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
      }
    )

  }

  updateRecord() {
    this.loading=true;
    const updatedRecord = this.recordForm.value;
    this.api.update("Blog/UpdatePost",updatedRecord).subscribe
    (
      (response)=>{
        this.loading=false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: response.message });
        this.recordForm.reset();
      }
      ,(
        error
      )=>{
        this.loading=false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
      }
    )

  }



  upload(event: any): void {
    this.loading=true
    const file: File = event.target.files[0];
    if (file) {

     this.imageUploadService.uploadImage(file)
     .subscribe
     ((imageUrl: string) => {
       this.imageUrl = imageUrl;
       
       this.recordForm.get('image')?.setValue(imageUrl);
       this.loading=false;
     }
     ,(error)=>{
      {
        
        this.loading=false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: error });

      }
     }
     );


    }
  }


  editor() {
    this.editorService.getEditorContent().subscribe(content => {
      this.editorContent = content;
      this.recordForm.get('description')?.setValue(this.editorContent);
    });
  }





}
